import { interactedWithGuestCommsAction } from '@bridebook/web/lib/inbox/guests/analytics/actions';
import { useDispatch } from '@bridebook/web/lib/utils';
import { useTranslation } from 'next-i18next';
import { ComponentProps } from 'react';
import { TeamCheckboxes } from './team-checkboxes';

interface IProps {
  guestId: string;
  onClick: ComponentProps<typeof TeamCheckboxes>['onEmailClick'];
  email: string;
  isHead: boolean;
  headEmail?: string;
}

export const EmailButton = ({ guestId, onClick, email, isHead, headEmail }: IProps) => {
  const { t } = useTranslation('inbox');
  const dispatch = useDispatch();

  const handleClick = () => {
    onClick(guestId);
  };

  const handleClickNoEmail = () => {
    onClick(guestId);
    dispatch(
      interactedWithGuestCommsAction({
        action: 'clicked',
        location: 'guestComms',
        section: 'selectRecipients',
        element: 'missingEmailHyperlink',
        elementLabel: 'Add missing email',
      }),
    );
  };

  if (email && (isHead || email !== headEmail)) {
    return (
      <button className="text-left text-sm font-normal break-all" onClick={handleClick}>
        {email}
      </button>
    );
  }

  if (email && !isHead) {
    if (email === headEmail) {
      return (
        <button className="text-left text-sm font-normal text-space-60" onClick={handleClick}>
          {t('guests.createMessageFlow.recipients.sameAsMainGuest')}
        </button>
      );
    }
    return (
      <button className="text-left text-sm font-normal break-all" onClick={handleClick}>
        {email}
      </button>
    );
  }
  return (
    <button
      className="text-left text-sm font-normal text-indigo-crush"
      onClick={handleClickNoEmail}>
      {t('guests.createMessageFlow.recipients.addMissingEmail')}
    </button>
  );
};
